













































import Vue from "vue"
import {
  SOCIAL_FACEBOOK_ICON,
  SOCIAL_GITHUB_ICON,
  SOCIAL_LINKED_IN_ICON,
  SOCIAL_TWITTER_ICON,
} from "~/config/icon"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"
import EditLinkIcon from "~/components/guideline/icon/EditLinkIcon.vue"

export default Vue.extend({
  components: {
    ConversionButton,
    EditLinkIcon,
  },
  props: {
    facebookUrl: {
      type: String,
      required: true,
    },
    twitterUrl: {
      type: String,
      required: true,
    },
    githubUrl: {
      type: String,
      required: true,
    },
    linkedInUrl: {
      type: String,
      required: true,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      icon: {
        socialFacebook: SOCIAL_FACEBOOK_ICON,
        socialGithub: SOCIAL_GITHUB_ICON,
        socialLinkedIn: SOCIAL_LINKED_IN_ICON,
        socialTwitter: SOCIAL_TWITTER_ICON,
      },
    }
  },
  methods: {
    goToCreateForm() {
      this.$nuxt.$router.push({ path: "/profiles/edit/sns" })
    },
  },
})
